<template>
    <zk-admin-table title="体检套餐设置" :loading="loading" :table="table" @change="handleTableChange" @select="handleTableSelect">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button size="mini" icon="el-icon-search" circle @click="searchVisible = !searchVisible"></el-button>
                <el-button size="mini" icon="el-icon-refresh" circle @click="getData"></el-button>
                <!-- <el-button size="mini" icon="el-icon-upload2" circle @click="uploadVisible = true"></el-button> -->
                <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="handleAdd" v-if="permission.hospital_package_add"></el-button>
                <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleMultiUpdate" v-if="permission.hospital_package_edit"></el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete" v-if="permission.hospital_package_delete"></el-button>
            </el-row>
        </template>
        <template v-slot:search>
            <search-form @search="handleSearch" v-show="searchVisible" />
        </template>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  align="left" v-for="(v, idx) in table.columns" :prop="v.field" :label="v.title"
            :width="v.width" :formatter="v.formatter" :key="idx" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" width="120" label="操作" fixed="right" v-if="permission.hospital_package_edit">
            <template slot-scope="scope">
                <el-button type="warning" size="mini" @click="handleUpdate(scope.row)" icon="el-icon-edit"></el-button>
            </template>
        </el-table-column>
        <template v-slot:dialog>
            <data-form :visible="dialogVisible" :form="form" @close="dialogClose" @update="getData" :isNew="isNew"/>
            <data-upload :visible="uploadVisible" @close="dialogClose" />
        </template>
    </zk-admin-table>
</template>

<script>
import SearchForm from './widgets/searchForm'
import DataForm from './widgets/dataForm'
import DataUpload from './widgets/dataUpload'
import data from './data'

export default {
    name: 'hospital-package2-list',
    path: '/main/hospital/package2/list',
    components: {
        SearchForm,
        DataForm,
        DataUpload
    },
    data() {
        return {
            loading: false,
            table: data.table,
            dialogVisible: false,
            searchVisible: true,
            uploadVisible: false,
            search: {},
            form: {},
            isNew: false,
            multipleSelection: [],
            permission: {}
        }
    },
    methods: {
        dialogClose() {
            this.dialogVisible = false
            this.uploadVisible = false
            this.getData()
        },
        handleAdd() {
            this.form = { gender: [], zglx:[]}
            this.isNew = true
            this.dialogVisible = true
        },
        handleSearch(e) {
            this.search = e
            this.table.page = 1
            this.getData()
        },
        handleTableChange(e) {
            this.table = e
            this.getData()
        },
        handleTableSelect(val) {
            this.multipleSelection = val
        },
        async handleMultiUpdate() {
            if (this.multipleSelection.length !== 1) {
                this.$message.error('请选择一条记录')
                return
            }
            this.handleUpdate(this.multipleSelection[0])
        },
        async handleUpdate(row) {
            this.isNew = false
            row.med_items = row.med_items || []
            var temp = JSON.stringify(row)
            this.form = JSON.parse(temp)
            this.dialogVisible = true
        },
        async handleDelete() {
            if (this.multipleSelection.length < 1) {
                this.$message.error('请选择要删除的对象')
                return
            }
            this.loading = true
            for (let e of this.multipleSelection) {
                await this.$http.delete(`/hospital/package2/${e.id}`)
            }
            this.$message.success('删除成功')
            this.getData()
            this.loading = false
        },
        async getData() {
            this.loading = true
            try {
                const resp = await this.$http.get(`/hospital/package2?page=${this.table.page}&pageSize=${this.table.pageSize}`, { params: this.search })
                if (!resp.data) {
                    this.$message.error(resp.data.msg)
                } else {
                    this.table.data = resp.data.data.records
                    this.table.total = resp.data.data.total
                }
            } catch (e) {
                this.$message.error(e.message)
            }
            this.loading = false
        },
        async getPermission() {
            const resp = await this.$http.get('/permission')
            this.permission = resp.data
        }
    },
    mounted() {
        this.getPermission()
        this.getData()
    }
}
</script>
